// extracted by mini-css-extract-plugin
export var container = "_5p-0";
export var infoButton = "_5p-1";
export var label = "_5p-3";
export var labelExpanded = "_5p-4";
export var price = "_5p-5";
export var priceExpanded = "_5p-6";
export var title = "_5p-2";